import styles from "./NotePreview.module.css";

export default function NotePreview({
  note = "",
  isLoading = false,
  error = null,
}) {
  const content = note || "Preview unavailable.";

  return (
    <div className={styles.previewBox} aria-live="polite" aria-busy={isLoading}>
      {error ? (
        <p className={styles.errorText}>{error}</p>
      ) : (
        <>
          {isLoading ? (
            <p className={styles.statusText}>Updating preview...</p>
          ) : null}
          {content}
        </>
      )}
    </div>
  );
}